// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RejectPanelContainer {
    height: 100vh;
    position: fixed;
    top: 0px;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.24);
    display: flex;
    align-items: center;

    .Rejectpanel {
        width: 40%;
        padding: 30px 30px;
        background-color: white;
        margin-left: 18%;
        border-radius: 20px;
        box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.253);

        textarea {
            width: 100%;
            height: 20vh;
        }
    }
}

.tableDesign {
    border: 1px solid #98BDED;

    table {
        width: 100%;
        border-collapse: collapse;
        /* border: 1px solid #AFD1F6 !important; */

        thead {
            tr {
                color: 'white';
                height: '3.5rem';
                /* border: 1px solid #AFD1F6 !important; */

                th {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }

        tbody {
            tr {
                color: 'white';
                height: '3.5rem';
                border: 1px solid #AFD1F6 !important;

                td {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }


    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ProposalManagement/rejectpanel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,mBAAmB;;IAEnB;QACI,UAAU;QACV,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,gDAAgD;;QAEhD;YACI,WAAW;YACX,YAAY;QAChB;IACJ;AACJ;;AAEA;IACI,yBAAyB;;IAEzB;QACI,WAAW;QACX,yBAAyB;QACzB,0CAA0C;;QAE1C;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,0CAA0C;;gBAE1C;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;QAEA;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,oCAAoC;;gBAEpC;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;;IAGJ;AACJ","sourcesContent":[".RejectPanelContainer {\n    height: 100vh;\n    position: fixed;\n    top: 0px;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.24);\n    display: flex;\n    align-items: center;\n\n    .Rejectpanel {\n        width: 40%;\n        padding: 30px 30px;\n        background-color: white;\n        margin-left: 18%;\n        border-radius: 20px;\n        box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.253);\n\n        textarea {\n            width: 100%;\n            height: 20vh;\n        }\n    }\n}\n\n.tableDesign {\n    border: 1px solid #98BDED;\n\n    table {\n        width: 100%;\n        border-collapse: collapse;\n        /* border: 1px solid #AFD1F6 !important; */\n\n        thead {\n            tr {\n                color: 'white';\n                height: '3.5rem';\n                /* border: 1px solid #AFD1F6 !important; */\n\n                th {\n                    border: 1px solid #AFD1F6 !important;\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                color: 'white';\n                height: '3.5rem';\n                border: 1px solid #AFD1F6 !important;\n\n                td {\n                    border: 1px solid #AFD1F6 !important;\n                }\n            }\n        }\n\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
